export const indefiniteStartDate = '1970-01-01'
export const indefiniteEndDate = '2099-12-31'
